export const BOOKMARKED_QUESTIONS = 'bookmarked-questions';
